import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Bar',
  props: {
    title: {
      type: String,
      default: ''
    },
    x: {
      type: String,
      default: 'x'
    },
    y: {
      type: String,
      default: 'y'
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 254
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    scale: function scale() {
      return [{
        dataKey: 'x',
        title: this.x,
        alias: this.x
      }, {
        dataKey: 'y',
        title: this.y,
        alias: this.y
      }];
    }
  },
  created: function created() {// this.getMonthBar()
  },
  methods: {// getMonthBar() {
    //   this.$http.get('/analysis/month-bar')
    //     .then(res => {
    //       this.data = res.result
    //     })
    // }
  }
};